
export interface IMenuItem {
    text: string,
    heading?: boolean,
    link?: string,     // internal route links
    elink?: string,    // used only for external links
    target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
    icon?: string,
    alert?: string,
    code?: MENU_CODE
    submenu?: IMenuItem[]
  }

export enum MENU_CODE {
  CAMPIONARIO = "CAMPIONARIO",
  KPI_CAMPIONARIO = "KPI_CAMPIONARIO",
  CAMPIONARIO_OPERATION = "CAMPIONARIO_OPERATION",
  KPI_CAMPIONARIO_OPERATION = "KPI_CAMPIONARIO_OPERATION",
  AUDIT = "AUDIT",
  UTENTI = "UTENTI",
  RUOLI = "RUOLI",
  COMMESSE_MANUALI = "COMMESSE_MANUALI"
}

export enum MENU_PATH {
  CAMPIONARIO = "/checks/sample",
  KPI_CAMPIONARIO = "/checks/kpisample",
  CAMPIONARIO_OPERATION = "/checks/sampleoperations",
  KPI_CAMPIONARIO_OPERATION = "/checks/kpisampleoperations",
  AUDIT = "/audits/audit",
  UTENTI = "/user",
  RUOLI = "/roles",
  COMMESSE_MANUALI = "/commesse/commessemanuali"
}

const Home = {
    text: 'Home',
    link: '/home',
    icon: 'fa fa-home',
    roles: []
};

const SampleChecks = {
  translate: 'menu.samplechecks',
  link: MENU_PATH.CAMPIONARIO,
  icon: 'fas fa-tshirt',
  code: MENU_CODE.CAMPIONARIO
};

const KpiSampleChecks = {
  translate: 'menu.kpisamplechecks',
  link: MENU_PATH.KPI_CAMPIONARIO,
  icon: 'fas fa-tachometer-alt',
  code: MENU_CODE.KPI_CAMPIONARIO
};

const SampleOperationsChecks = {
  translate: 'menu.samplechecksOperations',
  link: MENU_PATH.CAMPIONARIO_OPERATION,
  icon: 'fas fa-tshirt',
  code: MENU_CODE.CAMPIONARIO_OPERATION
};

const KpiSampleOperationsChecks = {
  translate: 'menu.kpisamplechecksOperations',
  link: MENU_PATH.KPI_CAMPIONARIO_OPERATION,
  icon: 'fas fa-tachometer-alt',
  code: MENU_CODE.KPI_CAMPIONARIO_OPERATION
};

const Audits = {
  translate: 'menu.audits',
  link: MENU_PATH.AUDIT,
  icon: 'fas fa-expand',
  code: MENU_CODE.AUDIT
};

const Users = {
  translate: 'menu.users',
  link: MENU_PATH.UTENTI,
  icon: 'fa fa-user',
  code: MENU_CODE.UTENTI
};

const Roles = {
  translate: 'menu.roles',
  link: MENU_PATH.RUOLI,
  icon: 'fa fa-user-cog',
  code: MENU_CODE.RUOLI
};

const CommesseManuali = {
  translate: 'menu.commesseManuali',
  link: MENU_PATH.COMMESSE_MANUALI,
  icon: 'fas fa-shopping-cart',
  code: MENU_CODE.COMMESSE_MANUALI
};

export const menu = [
  //Home,
  SampleChecks,
  KpiSampleChecks,
  SampleOperationsChecks,
  KpiSampleOperationsChecks,
  Audits,
  CommesseManuali,
  Users,
  Roles
];
